import Dropdown from "react-dropdown";
import "react-dropdown/style.css";

const DropDownInput = ({ value, onValueChange, options, placeholder }) => {
  return (
    <Dropdown
      className="w-full md:w-95.7% mt-10 h-[45px] rounded-lg"
      options={options}
      value={value}
      onChange={onValueChange}
      placeholder={placeholder}
    />
  );
};

export default DropDownInput;
